import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { getProductListColumns } from './productListColumns';

import type { TypeProduct } from '~/types/product.types';

/**
 * [상품 등록/조회] 페이지 > 테이블 컬럼 정의
 */
const getProductRegisterColumnDefs = ({ onClickViewDetail }: { onClickViewDetail: (skuCode: string) => void }) => {
  const columnDefs: TypeTableColumn<TypeProduct>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 96,
      meta: { selection: true },
    },
    ...getProductListColumns({ onClickViewDetail }),
  ];

  return { columnDefs };
};

export default getProductRegisterColumnDefs;
